/*
 * KAIRN KYOTO — 紹介元（utm_source / utm_content）を注文そのものに記録する（2026-10-18）
 *
 * ■ なぜ要るか
 *   LiquorShop Kyo（ANNIE HALL）との委託条件で「POPのQRから30日以内に成立した
 *   サイト注文も店の売上とみなし25%を払う。判定は注文に記録される流入情報で行う」
 *   と約束している。Shopify標準のUTM帰属はセッション単位なので、
 *   QRをスマホで読んで後日PCで買う・日を空けて戻る、で判定が曖昧になる。
 *   来訪時のUTMを30日保存し、カート属性として注文に載せる。
 *   注文詳細の「追加情報」に 紹介元 / 紹介POP / 紹介日 が出る。
 *
 * ■ ルール
 *   - URLに utm_source が来たら上書き（最後に来たものが勝つ。30日もそこから数え直す）
 *   - ただし委託先（PROTECTED）の記録は、有効な30日間は他の流入で上書きしない（2026-10-27）。
 *     条件書は「QRから30日以内の注文は店の売上」なので、QRのあとInstagram等のUTM付きリンクで
 *     戻ってきて買った場合も店の分として残す。同じ委託先のQRをもう一度読んだときだけ
 *     紹介POPと紹介日を更新する（30日もそこから数え直す）
 *   - 30日で失効。失効したらカート側の属性も空にして消す
 *   - 書き込みは /cart/update.js の attributes だけ。商品・数量・メモには触れない
 *   - 来訪した時点で（カートが空でも）書く。Shopify は訪問者ごとにカートを既に持っているので
 *     新しく作るわけではない。先に載せておけば、カート追加の直後に遷移しても取りこぼさない
 *   - 値が変わらないときは POST しない（毎ページ GET /cart.js の1回だけ）
 *
 * ■ ja / en
 *   保存は cookie（path=/）なので /en/ でも同じ値が読める。
 *   カートは日英で同一（token が同じ）なので、読み書きは接頭辞なしの /cart.js・/cart/update.js に固定する。
 *   window.routes は使わない: theme dev で /en/cart/update.js（と /en/cart/add.js）が
 *   値を書く POST だけ 404 を返した（2026-10-18）。接頭辞なしは日英どちらのページからも 200。
 *
 * ■ 端末をまたぐ場合
 *   cookie は端末ごと。QRを読んだ端末と別の端末で買われた注文はここでは拾えない
 *   （Shopify標準の帰属でも拾えない）。そこは条件書の運用側で扱う。
 */
(function () {
  var STORE_KEY = 'kairn_ref';
  var MAX_AGE_SEC = 30 * 24 * 60 * 60;
  var ATTR = { source: '紹介元', content: '紹介POP', date: '紹介日' };
  // 委託先の utm_source。ここに載せた紹介元は30日間、他の流入で上書きしない
  var PROTECTED = ['liquorshopkyo'];

  function readCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + STORE_KEY + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function writeCookie(value) {
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      STORE_KEY + '=' + encodeURIComponent(value) + '; Max-Age=' + MAX_AGE_SEC + '; Path=/; SameSite=Lax' + secure;
  }

  function clearStored() {
    document.cookie = STORE_KEY + '=; Max-Age=0; Path=/; SameSite=Lax';
    try {
      localStorage.removeItem(STORE_KEY);
    } catch (e) {}
  }

  function clean(value) {
    return String(value || '')
      .trim()
      .slice(0, 100);
  }

  // JSTの日付（YYYY-MM-DD）。30日判定を注文画面だけで読めるようにする
  function jstDate(ms) {
    return new Date(ms + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);
  }

  function capture() {
    var params = new URLSearchParams(location.search);
    var source = clean(params.get('utm_source'));
    if (!source) return;
    var current = load();
    if (current && PROTECTED.indexOf(current.s) !== -1 && current.s !== source) return;
    var ref = { s: source, c: clean(params.get('utm_content')), t: Date.now() };
    var json = JSON.stringify(ref);
    writeCookie(json);
    try {
      localStorage.setItem(STORE_KEY, json);
    } catch (e) {}
  }

  // cookie を正とし、消されていたら localStorage から戻す。どちらも30日で切る
  function load() {
    var raw = readCookie();
    if (!raw) {
      try {
        raw = localStorage.getItem(STORE_KEY);
      } catch (e) {}
    }
    if (!raw) return null;
    var ref;
    try {
      ref = JSON.parse(raw);
    } catch (e) {
      clearStored();
      return null;
    }
    if (!ref || !ref.s || !ref.t || Date.now() - ref.t > MAX_AGE_SEC * 1000) {
      clearStored();
      return null;
    }
    return ref;
  }

  function desiredAttributes(ref) {
    // 値を '' にすると Shopify は属性を消す
    return {
      [ATTR.source]: ref ? ref.s : '',
      [ATTR.content]: ref ? ref.c : '',
      [ATTR.date]: ref ? jstDate(ref.t) : '',
    };
  }

  var syncing = null;
  var again = false;

  function sync() {
    if (syncing) {
      again = true;
      return syncing;
    }
    syncing = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart) return;
        var want = desiredAttributes(load());
        var have = cart.attributes || {};
        var diff = {};
        var changed = false;
        Object.keys(want).forEach(function (key) {
          if ((have[key] || '') !== want[key]) {
            diff[key] = want[key];
            changed = true;
          }
        });
        if (!changed) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: diff }),
        }).then(function (res) {
          if (!res.ok) throw new Error('cart/update.js ' + res.status);
        });
      })
      .catch(function (e) {
        console.warn('[kairn-referral]', e);
      })
      .finally(function () {
        syncing = null;
        if (again) {
          again = false;
          sync();
        }
      });
    return syncing;
  }

  capture();
  sync();

  // カート追加・数量変更のたびに合わせる。publish は購読者の戻り値を待つので、
  // ここでは待たせずに投げるだけにする
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      sync();
    });
  }

  // 戻るボタンで bfcache から復帰したときも（カート追加 → 戻る、の経路）
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) sync();
  });
})();
